export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://bmwstory.efraincy.life";

export default {
  LOGIN: "/api/Denglu/login",
  GET_STORY_LIST: "/api/Tiezi/getTiezilist",
  GET_COMMENT_LIST: "/api/Pinglun/getPinglunlist",
  GET_TIEZI_COMMENT_LIST: "/api/Pinglun/getPinglunlisttiezi",
  UPLOAD: "/api/common/upload",
  GET_TIEZI: "/api/Tiezi/getTiezi",
  ADD_TIEZI: "/api/Tiezi/setTiezi",
  DELETE_TIEZI: "/api/Tiezi/delTiezi",
  EDIT_COMMENT: "/api/Pinglun/setPinglun",
  GET_COMMENT: "/api/Pinglun/getPinglun",
  DELETE_COMMENT: "/api/Pinglun/delPinglun",
  ADD_CATEGORY: "/api/Category/setCategory",
  GET_CATEGORY:'/api/Category/delCategory',
  DELETE_CATEGORY: "/api/Category/delCategory",
  GET_CATEGORY_LIST: "/api/Category/getCategoryList",
  GET_CATEGORY_LIST_NOPAGE: "/api/Category/getCategoryListN",
};
